// One line with an ellipsis, the whole text as the native tooltip. The text
// stays whole in the DOM (CSS cuts it), so screen readers read all of it.
export function Truncate({ text, className = '', as = 'span' }: { text: string; className?: string; as?: 'span' | 'div' }) {
  const Tag = as;
  return <Tag className={`block min-w-0 truncate ${className}`} title={text}>{text}</Tag>;
}
